import { ChatModel } from '@agent/agent-interface/contact-view/chat/model/chat-model';
import { ScreenSharingInfoAndChat, ScreenSharingStatus } from '@agent/agent-interface/contact-view/chat/model/screen-sharing-info';
import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { OpenTokService } from '@agent/agent-interface/contact-view/chat/services/open-tok.service';
import { ScreenSharingStatusService } from '@agent/agent-interface/contact-view/chat/services/screen-sharing-status.service';
import { Injectable } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { Logger } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class ScreenSharingService {
  $el: HTMLDivElement;

  private readonly _destroy$ = new Subject<void>();
  readonly destroy$ = this._destroy$.asObservable();

  constructor(
    private readonly logger: Logger,
    private readonly openTokService: OpenTokService,
    private readonly chatSocketService: ChatSocketService,
    private readonly screenSharingStatusService: ScreenSharingStatusService
  ) {
    this.$el = document.createElement('div');
    this.$el.style.width = '100%';
    this.$el.style.height = '100%';
  }

  init() {
    this.screenSharingStatusService.screenSharingInfo$.pipe(takeUntil(this.destroy$)).subscribe(this.handleStatusChanged.bind(this));
  }

  destroy() {
    this._destroy$.next();
  }

  askForScreenSharingSession() {
    const activeChat = this.chatSocketService.activeChat;
    if (activeChat) {
      activeChat.screenSharingInfos.askForSharing();
      this.chatSocketService.sendScreenSharingDemandMessage(activeChat.customerId);
    }
  }

  stopScreenSharing(chat: ChatModel) {
    if (chat) {
      chat.screenSharingInfos.cancelSharing();
      this.chatSocketService.sendStopScreenSharingMessage(chat.customerId);
    }
  }

  handleStartScreenSharingSession(value: ScreenSharingInfoAndChat) {
    this.openTokService.stopPreviousSession();
    const { info, chat } = value;
    chat.screenSharingInfos.acceptSharing(info.apiKey, info.token, info.sessionId);
    this.openTokService.initSession(info.apiKey, info.token, info.sessionId, this.$el, chat);
    this.openTokService.connect().subscribe(
      () => {
        this.logger.info('[SS][SESSION] connected');
      },
      err => {
        this.logger.error(`[SS][SESSION] ERROR ${err}`);
      }
    );
  }

  private handleStatusChanged(value: ScreenSharingInfoAndChat) {
    if (!value) {
      return;
    }
    const { info, chat } = value;
    switch (info.status) {
      case ScreenSharingStatus.NOT_STARTED:
        chat.screenSharingInfos.cancelSharing();
        break;
      case ScreenSharingStatus.PENDING_INVITATION:
        chat.screenSharingInfos.askForSharing();
        break;
      case ScreenSharingStatus.ONGOING:
        this.handleStartScreenSharingSession(value);
        break;
      default:
        break;
    }
  }
}
